import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M12.55 26a4 4 0 00-.05.5 3.5 3.5 0 007 0 4 4 0 00-.05-.5z"/><path d="M24.36 12.54A8.53 8.53 0 0017 4.07V3a1 1 0 00-2 0v1.06a8.29 8.29 0 00-7.37 8.19c0 8.23-4.64 6.47-4.64 11v.92A1.84 1.84 0 004.86 26h22.28A1.84 1.84 0 0029 24.17v-.92c0-4.48-4.53-2.81-4.64-10.71z"/>';
export var BellSVG = function BellSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BellSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BellSVG);